import { getDesignProductPresenters } from './productsPresenter';
import type { SupportedLocale } from '@99designs/i18n';
import type { ProductKey } from './types';

export const getDesignProducts = (locale: SupportedLocale, keys: ProductKey[]) => {
    const presenters = getDesignProductPresenters(locale);
    const products = Object.keys(presenters)
        .filter((key) => keys.includes(key as ProductKey))
        .map((key) => presenters[key as ProductKey]);

    return products;
};
